import { isNumeric } from 'utils/helperMethods';
import { validators } from '../../utils/validators';

// Define the email validation function with the provided regex
const validateEmail = (email) => {
    if (!email) return false;
    const regex = /^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/;
    return !regex.test(email);
};

const validate = values => {
    console.log("values: ", values);
    const { REQUIRED, EMAIL, MAX_LENGTH, ALPHA } = validators;
    const errors = {};
    if (REQUIRED(values.integrationType)) {
        errors.integrationType = 'Please select Integration Type';
    }
    if (REQUIRED(values.name)) {
        errors.name = 'Please enter Merchant Name';
    }

    if (values.name) {
        errors.name = MAX_LENGTH(values.name, 50);
    }
    if (REQUIRED(values.pocName)) {
        errors.pocName = 'Please enter a POC name';
    }
    if (REQUIRED(values.pocName)) {
        errors.pocName = 'Please enter a POC name';
    }
    if (ALPHA(values.pocName)) {
        errors.pocName = 'Please enter valid POC name';
    }

    if (REQUIRED(values.email)) {
        errors.email = 'Please enter a email address';
    } else if (validateEmail(values.email)) {
        errors.email = 'Please enter a valid email address';
    }

    if (REQUIRED(values.pinCode) || values.pinCode?.length !== 6) {
        errors.pinCode = 'Please enter 6 digit Pin Code';
    }
    if (!isNumeric(values.pinCode)) {
        errors.pinCode = 'Please enter valid 6 digit Pin Code';
    }
    if (REQUIRED(values.turnoverCategory)) {
        errors.turnoverCategory = 'Please select a Turnover Category';
    }
    if (REQUIRED(values.state)) {
        errors.state = 'Please select a state';
    }
    if(REQUIRED(values.mobileNumber)){
        errors.mobileNumber=  'Please enter valid 10 digit mobile number';
    }
    if (values.mobileNumber && values.mobileNumber.length !== 10) {
        errors.mobileNumber = 'Please enter valid 10 digit mobile number';
    }
    if (values.mobileNumber && !isNumeric(values.mobileNumber)) {
        errors.mobileNumber = 'Please enter valid 10 digit mobile number';
    }

    if (REQUIRED(values.pocPhoneNumber)) {
        errors.pocPhoneNumber = 'Please enter POC mobile number';
    }
    if (values.pocPhoneNumber && values.pocPhoneNumber.length !== 10) {
        errors.pocPhoneNumber = 'Please enter valid 10 digit mobile number';
    }
    if (values.pocPhoneNumber && !isNumeric(values.pocPhoneNumber)) {
        errors.pocPhoneNumber = 'Please enter valid 10 digit mobile number';
    }

    if (REQUIRED(values.city)) {
        errors.city = 'Please enter a city';
    }
    if (REQUIRED(values.addressLine1)) {
        errors.addressLine1 = 'Please enter address';
    }
    if (MAX_LENGTH(values.addressLine1, 256)) {
        errors.addressLine1 = 'Address length can not be more than 256 chars';
    }

    // if (values.businessType !== 'sole proprietorship') {
    //     if (REQUIRED(values.gstNumber) || values.gstNumber?.length !== 15) {
    //         errors.gstNumber = 'Please enter 15 digit GST Number';
    //     }
    // }
    if (values.noOfStores) {
        if (!isNumeric(values.noOfStores)) {
            errors.noOfStores = 'Please enter a valid number between 1 to 100';
        } else if (parseInt(values.noOfStores) < 1) {
            errors.noOfStores = 'Number of stores cannot be less than 1';
        }else if (parseInt(values.noOfStores) > 100) {
            errors.noOfStores = 'Number of stores cannot be greater than 100';
        }
    }    
    if (values.numberOfYearsInBusiness) {
        if (!isNumeric(values.numberOfYearsInBusiness)) {
            errors.numberOfYearsInBusiness = 'Please enter a valid number between 1 to 100';
        } else if (parseInt(values.numberOfYearsInBusiness) < 1) {
            errors.numberOfYearsInBusiness = 'Number of stores cannot be less than 1';
        }else if (parseInt(values.numberOfYearsInBusiness) > 100) {
            errors.numberOfYearsInBusiness = 'Year Of Experience cannot be greater than 100';
        }
    }
    
    if (REQUIRED(values.pan) || values.pan?.length !== 10) {
        errors.pan = 'Please enter 10 digit PAN Number';
    }

    // Similarly update the userEmail validation
    if (values.userEmail && validateEmail(values.userEmail)) {
        errors.userEmail = 'Please enter a valid email address';
    }

    if (REQUIRED(values.axisAcquiredMerchantId)) {
        errors.axisAcquiredMerchantId = 'Please enter Axis MID';
    }

    if (values.axisAcquiredMerchantId) {
        errors.axisAcquiredMerchantId = MAX_LENGTH(
            values.axisAcquiredMerchantId,
            50
        );
    }

    // if (REQUIRED(values.relationshipManagerId)) {
    //     errors.relationshipManagerId = 'Please enter Relationship Manager Name';
    // }

    if (REQUIRED(values.merchantCategory)) {
        errors.merchantCategory = 'Please enter Merchant Category';
    }

    if (REQUIRED(values.subMerchantCategory)) {
        errors.subMerchantCategory = 'Please enter Sub Merchant Category';
    }

    if (REQUIRED(values.mcc)) {
        errors.mcc = 'Please enter Sub Merchant Category Code';
    }

    if (REQUIRED(values.turnoverAmountRange)) {
        errors.turnoverAmountRange = 'Please select Turnover Amount Range';
    }
    console.log("errors : ", errors);
    return errors;
};

export default validate;
